import { render, staticRenderFns } from "./dub_skyexpress.vue?vue&type=template&id=28cdcb5b&"
import script from "./dub_skyexpress.vue?vue&type=script&lang=js&"
export * from "./dub_skyexpress.vue?vue&type=script&lang=js&"
import style0 from "./dub_skyexpress.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports